import styled from '@emotion/styled';
import { Container } from '../../Surfaces/Container';
import { breakpoint, spacing } from '../../../themes';

export const WizardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.mediumLow};
`;

export const WizardCard = styled(Container)`
  gap: ${spacing.mediumHigh};
  padding: ${spacing.mediumLow};

  @media (max-width: ${breakpoint.medium}px) {
    padding: ${spacing.small};
  }
`;
